import styled from '@emotion/styled';
import { Text } from 'components';

export const EmptyCartContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    padding-bottom: 90px;
    padding: ${({ theme }) => theme.base.spacing[4]};
`;

export const BottomBar = styled.div`
    position: sticky;
    height: 90px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    left: 0;
    padding: ${({ theme }) => theme.base.spacing[4]};
`;

export const CartEmptySubtitle = styled(Text)`
    text-align: center;
    margin-top: ${({ theme }) => theme.base.spacing[2]};
`;
